import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import { ServiceCard } from "../components/common/Cards";
import CtaBanner from "../components/common/CtaBanner";
import { services } from "../data/content";

export default function Services() {
  return (
    <>
      <PageHeader title="Our Services" crumbs={[{ label: "Services" }]} />
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="What We Offer"
            title="Premium Taxi Services <span>For Every Need</span>"
            text="From everyday city commutes to luxury chauffeur experiences, Taxi24hrs has the perfect service for you."
          />
          <div className="grid grid-3">
            {services.map((s) => <ServiceCard key={s.id} service={s} />)}
          </div>
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
